// Modules
import React from 'react';
import { CellProps } from 'react-table';

// Components
/* import NoActivity from '../../components/Column/NoActivity';
import ActivityCatchCell from '../BasstrakkTable/ActivityCatchCell'; */

// Types
import { ICatchesTableData } from '../../types';

// Util
import { formatTime } from '../../util/util';

// Config
import AnglerCell from '../../components/Column/AnglerCell';
import { CLASS_PREFIX, /* NO_CATCHES_TEXT */ } from '../../config';

/**
 * Big Bass Leaderboard columns
 */
export const BigBassColumns = [
  {
    Header: '',
    id: 'hidden',
    columns: [
      {
        Header: 'Angler',
        accessor: ({ Angler }) => Angler.FISHERMAN_PHONENAME,
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--700 ${CLASS_PREFIX}cell__angler`,
        headerClassName: `${CLASS_PREFIX}header`,
        minWidth: 100,
        Cell: ({ row, index, width }: CellProps<ICatchesTableData>) => (
          <AnglerCell
            anglerName={row.original.Angler.FISHERMAN_PHONENAME}
            isLeader={
              row.original.AnglerId === row.original.BigBassLeader.AnglerId
            }
            index={index}
            isExpanded={row.isExpanded}
            width={width}
            tid={row.original.TournamentId}
          />
        ),
      },
      {
        Header: 'Weight',
        accessor: 'FishWeightPdsOz',
        width: 75,
        id: 'fishWeight',
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--700`,
        headerClassName: `${CLASS_PREFIX}header`,
      },
      {
        Header: 'Catch Time',
        accessor: 'Time',
        width: 100,
        id: 'catchTime',
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--600`,
        Cell: ({ value }) => (value ? formatTime(value) : ''),
      },
      {
        Header: '',
        id: 'activity',
        // We want this column to still be sortable so we will use the weight
        // (string) as the accessor value
        accessor: originalRow => {
          const lastCatch = originalRow.Catches.slice(-1)[0];
          // If an angler doesn't have any catches just say so
          if (!lastCatch) {
            return 'No Activity';
          }
          // By returning the weight as the value for the accessor this allows
          // this column to be sorted by that weight and not by what's returned in
          // the "Cell" below. There would be no need to sort
          // since all the columns would start with (New Catch...)
          return lastCatch.FishWeightPdsOz;
        },
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell__activity`,
        headerClassName: `${CLASS_PREFIX}header`,
        minWidth: 175,
        Cell: () => {
          return null
        }
        /* Cell: ({ value, row }) => {
          if (value !== NO_CATCHES_TEXT) {
            const lastCatch = row.original.Catches.slice(-1)[0];
            return (
              <ActivityCatchCell
                key={row.original.FISHERMAN_PHONENAME}
                row={row}
                lastCatch={lastCatch}
              />
            );
          }
          return <NoActivity classPrefix={CLASS_PREFIX} />;
        }, */
      },
    ],
  },
];
